export { MediaAndTextSideBySide } from '@/components/common/MediaAndTextSideBySide/MediaAndTextSideBySide';
